const RecurringTypes = Object.freeze({
  All: 0,
  BiYearly: 1,
  Yearly: 2,
  Quaterly: 3,
  Monthly: 4,
  BiWeekly: 5,
  Weekly: 6,
  Daily: 7,
});

export default RecurringTypes;
